import { useIsRoute } from 'utils/hooks/useIsRoute'

export const useIsLuckyBirdAuth = () => useIsRoute('/auth/luckybird/*')?.isRoute
